import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import TasksHistoryComp from "./Component/AssignmentHistoryComp"

const AssignmentHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <TasksHistoryComp/>
        </div>
        <Footer />
        </>
    )
}

export default AssignmentHistory